import useModalEndCondition, {
  ANY_ITEM,
  COPY,
  DO_NOTHING,
  EMPTYGROUP,
  modalEndConditionState,
  MOVE
} from 'Hooks/useModalEndCondition/useModalEndCondition'
import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem,
  Grid,
  GRID_VARIANT_VERTICAL_BIG,
  GridCell,
  Tooltip
} from 'mailup-web-components'
import {
  saveTaskCallback,
  updateTaskStep2Callback
} from 'Pages/Task/recoil/callbacks/callbacks'
import { pageState, step2IsEnabledState } from 'Pages/Task/recoil/state/page'
import { ACTION_MOVE_COPY, taskState } from 'Pages/Task/recoil/state/task'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { ActionToExecute } from './ActionToExecute/ActionToExecute'
import { RecipinetsManagement } from './RecipinetsManagement/RecipinetsManagement'
import { SendSettings } from './SendSettings/SendSettings'

const TaskStep2 = () => {
  const intl = useIntl()
  const task = useRecoilValue(taskState)

  const { fetchGroups, fetchGroup } = useModalEndCondition()
  const step2IsEnabled = useRecoilValue(step2IsEnabledState)
  const [{ idTask }, setPageState] = useRecoilState(pageState)
  const saveTask = useRecoilCallback(saveTaskCallback, [])
  const updateTaskStep2 = useRecoilCallback(updateTaskStep2Callback, [])

  const [
    { items: groupItems, loaded: groupsLoadedFirstTime },
    setGroupConditionState
  ] = useRecoilState(modalEndConditionState)

  const handleConfirm = (e) => {
    updateTaskStep2()
    if (idTask === 0) {
      setPageState((prev) => ({
        ...prev,
        wizardStep: 3
      }))
    }
  }

  useEffect(() => {
    if (task.saveTask && idTask > 0) {
      saveTask(false)
    }
  }, [task.saveTask])

  const setGroupCondition = async () => {
    const objModelCopy = {
      label: '',
      value: -1
    }
    const objModelMoveFrom = {
      label: '',
      value: -1
    }
    const objModelMoveTo = {
      label: '',
      value: -1
    }
    const objModelEmpty = {
      label: '',
      value: -1
    }
    let check = DO_NOTHING
    // devo prevdere il caso con 0 e quindi prendo aggiungere anyItems
    const newGroupItems = groupItems.slice(0)
    newGroupItems.push(ANY_ITEM)

    // cerco nella lista locale, prima pagina
    let endFromGroup = newGroupItems.find(
      (el) => el.value === task.Detail.FromGroup
    )
    let endToGroup = newGroupItems.find(
      (el) => el.value === task.Detail.ToGroup
    )

    if (task.Detail.FromGroup === -1 && task.Detail.ToGroup > 0) {
      check = COPY
      if (!endToGroup) {
        // non presente nella lista locale, cerco su API
        endToGroup = await fetchGroup(task.Detail.ToGroup)
        newGroupItems.push(endToGroup)
      }
      objModelCopy.label = endToGroup.label
      objModelCopy.value = task.Detail.ToGroup
    } else if (task.Detail.FromGroup > -1 && task.Detail.ToGroup > 0) {
      check = MOVE
      if (!endFromGroup && task.Detail.FromGroup > 0) {
        // non presente nella lista locale, cerco su API
        endFromGroup = await fetchGroup(task.Detail.FromGroup)
        newGroupItems.push(endFromGroup)
      }
      if (!endToGroup) {
        // non presente nella lista locale, cerco su API
        endToGroup = await fetchGroup(task.Detail.ToGroup)
        newGroupItems.push(endToGroup)
      }
      objModelMoveFrom.label =
        task.Detail.FromGroup > 0 ? endFromGroup.label : ''
      objModelMoveFrom.value = task.Detail.FromGroup
      objModelMoveTo.label = endToGroup.label
      objModelMoveTo.value = task.Detail.ToGroup
    } else if (task.Detail.FromGroup > 0 && task.Detail.ToGroup === -1) {
      check = EMPTYGROUP
      if (!endFromGroup && task.Detail.FromGroup > 0) {
        // non presente nella lista locale, cerco su API
        endFromGroup = await fetchGroup(task.Detail.FromGroup)
        newGroupItems.push(endFromGroup)
      }
      objModelEmpty.label = endFromGroup.label
      objModelEmpty.value = task.Detail.FromGroup
    }

    setGroupConditionState((prev) => ({
      ...prev,
      check,
      copyValue: objModelCopy,
      emptyValue: objModelEmpty,
      moveFromValue: objModelMoveFrom,
      moveToValue: objModelMoveTo,
      items: newGroupItems,
      selectedGroups: [endToGroup],
      selectedGroupsTo: endFromGroup ? [endFromGroup] : [],
      loaded: true
    }))
  }

  const handleBack = () => {
    setPageState((prev) => ({
      ...prev,
      wizardStep: 1
    }))
  }

  useEffect(() => {
    if (groupsLoadedFirstTime) {
      setGroupCondition()
    }
  }, [groupsLoadedFirstTime])

  return (
    <>
      <Tooltip />
      <ActionToExecute />

      <Grid cols={3} variantVertical={GRID_VARIANT_VERTICAL_BIG}>
        {task.Detail.Action !== ACTION_MOVE_COPY && (
          <GridCell span={2}>
            <SendSettings />
          </GridCell>
        )}

        <GridCell span={task.Detail.Action === ACTION_MOVE_COPY ? 3 : 1}>
          <RecipinetsManagement
            fetchGroups={fetchGroups}
            fetchGroup={fetchGroup}
          />
        </GridCell>
      </Grid>

      <Flex justifyContent='space-between'>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          disabled={idTask > 0 && !step2IsEnabled}
          onClick={() => handleBack()}
          data-mu-test={`task-2-btn-back`}
        >
          {intl.formatMessage({ id: 'Load.Common.BtnBack' })}
        </Button>

        <FlexItem>
          <Button
            kind={BUTTON_VARIANT_PRIMARY}
            onClick={() => handleConfirm()}
            disabled={!step2IsEnabled}
            data-mu-test={`task-2-btn-goto-next-step`}
          >
            {idTask > 0
              ? intl.formatMessage({ id: 'Load.Task.SaveTask' })
              : intl.formatMessage({ id: 'Load.Task.Next' })}
          </Button>
        </FlexItem>
      </Flex>
    </>
  )
}

export default TaskStep2
